import RichText from './ui/RichText';
import Reveal from './ui/Reveal';
import { testimonials } from '../data/content';

const STARS = '★★★★★';

function TestimonialCard({ item, duplicate = false }) {
  return (
    <div className="tcard" aria-hidden={duplicate || undefined}>
      <div className="stars" aria-label="Rated 5 out of 5">
        {STARS}
      </div>
      <p>
        <RichText text={item.quote} />
      </p>
      <div className="who">
        <img
          className="av"
          src={item.photo}
          alt={duplicate ? '' : item.name}
          width="48"
          height="48"
          loading="lazy"
          decoding="async"
        />
        <div>
          <div className="name">{item.name}</div>
          <div className="role">{item.role}</div>
          {/* Always rendered — an empty company still reserves its line so the
              photo, name, role and company align across every card. */}
          <div className="company">{item.company}</div>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="alt tight" id="testimonials">
      <div className="wrap">
        <Reveal as="h2" className="h-sub center">
          What Industry Leaders Say About Captain Mustapha
        </Reveal>
        <Reveal as="p" className="lede center mt-m tsub">
          From LNG traders and technology providers to classification societies and industry
          consultants, these leaders recognize Captain Mustapha's unique ability to bridge
          technical, operational, and commercial understanding.
        </Reveal>
      </div>

      {/*
        The list is rendered twice so translateX(-50%) loops seamlessly.
        The second pass is aria-hidden so screen readers hear each quote once.
      */}
      <div className="marquee mt-l">
        <div className="mrow mrow-l">
          {testimonials.map((item) => (
            <TestimonialCard key={item.slug} item={item} />
          ))}
          {testimonials.map((item) => (
            <TestimonialCard key={`dup-${item.slug}`} item={item} duplicate />
          ))}
        </div>
      </div>
    </section>
  );
}
